<template>
    <div style="z-index: 4">
        <!-- Feedback menu -->
        <v-menu
            v-if="!feedback.hide && !isHidenFeedback"
            v-model="feedback.show"
            :close-on-content-click="false"
            offset-y
            top
            min-width="300"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fixed
                    bottom
                    right
                    :ripple="false"
                    dark
                    class="primary lighten-2"
                    :style="
                        show ? `transform: translateX(calc(-100% - ${isAtBottom ? MOVE_LEFT + 16 : 16}px))` : ''
                    "
                    style="
                        min-width: initial;
                        height: initial;
                        padding: 8px;
                        max-width: 40px;
                    "
                >
                    <v-icon>mdi-message-text</v-icon>
                </v-btn>
            </template>
            <v-card>
                <div class="primary white--text text-subtitle-1 px-4 py-2 elevation-2">
                    <v-icon color="white" left
                        >mdi-email</v-icon
                    >
                    เสนอแนะ / พบปัญหาการใช้งาน ?
                </div>
                <div class="px-3">
                    <v-textarea
                        class="mt-4"
                        outlined
                        counter="500"
                        v-model="feedback.message"
                        label="ส่งข้อความถึงทีมงาน Marketpett.."
                        required
                    ></v-textarea>
                </div>
                <v-row no-gutters class="py-2 px-3" align="center">
                    <v-btn small text color="grey" @click="hideFeedback()"> ซ่อน </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        text
                        class="mr-1"
                        @click="feedback.show = false"
                    >
                        ยกเลิก
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        :dark="!!feedback.message.length || feedback.loading"
                        :disabled="!feedback.message.length || feedback.loading"
                        @click="sendFeedback()"
                    >
                        ส่ง
                    </v-btn>
                </v-row>
            </v-card>
        </v-menu>

        <transition name="fade">
            <v-btn
                v-scroll="onScroll"
                v-show="show"
                @click="toTop()"
                fixed
                bottom
                right
                :ripple="false"
                class="primary"
                style="
                    min-width: initial;
                    height: initial;
                    padding: 8px;
                    max-width: 40px;
                "
                :style="
                    isAtBottom ? `transform: translateX(-${MOVE_LEFT}px)` : ''
                "
            >
                <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
        </transition>
    </div>
</template>

<script>
import api from "../../services/api";
export default {
    data() {
        return {
            show: false,
            feedback: { hide: false, show: false, message: "", loading: false },
            isAtBottom: false,
            MOVE_LEFT: 64,
        };
    },
    methods: {
        onScroll(e) {
            if (typeof window === "undefined") return;
            const yPos = window.pageYOffset || e.target.scrollTop || 0;
            // this.isAtBottom = this.$vuetify.breakpoint.smAndDown && document.body.clientHeight - window.innerHeight - yPos < 64;
            if (yPos > 250) this.show = true;
            else this.show = false;
        },
        toTop() {
            this.$vuetify.goTo(0);
        },
        async sendFeedback() {
            this.feedback.loading = true;
            let { success } = await api.postFeedback(this.feedback.message);
            this.feedback.loading = false;
            if (success) {
                api.makeAlert('ข้อความถูกส่งแล้ว', 'success');
                setTimeout(() => api.makeAlert('ขอบคุณสำหรับความคิดเห็น 🙏🏻', 'primary'), 2500);
            }
            this.feedback.message = "";
            this.feedback.show = false;
        },
        hideFeedback() {
            sessionStorage.setItem('feedback', 1)
            this.feedback.show = false;
            this.feedback.hide = true;
        }
    },
    mounted() {
        if (sessionStorage.getItem('feedback')) 
            this.feedback.hide = true;
        // let observer = new IntersectionObserver(
        //     (entries, observer) => {
        //         entries.forEach(entry => {
        //             if (entry.intersectionRatio != 1) {
        //                 console.log("Leaving")
        //             }
        //         });
        //     }
        // );
        // observer.observe(document.getElementById('x1'));
    },
    computed: {
        isHidenFeedback() {
            return this.$route.path.includes('/p/') || this.$route.path.includes('/s/');
        }
    },
};
</script>

<style>
</style>